import { useMutation } from '@tanstack/react-query'
import { getHeaders } from 'services/api/utils'
import { findOutWhichEnv, getEnvPath } from 'utils/env'
import { downloadFile } from 'utils/exportFile'

const env = findOutWhichEnv()
const BASE_URL = `${getEnvPath(env)}/1.0/api`

/**
 * Exports the pricing analytics report data.
 * @param {Object} payload - The parameters for the export.
 * @param {string} payload.wabaId - The WhatsApp Business Account ID.
 * @param {Date} payload.startDate - The start date for the report.
 * @param {Date} payload.endDate - The end date for the report.
 * @param {Array<string>} payload.phoneNumbers - The phone numbers to include in the report.
 * @param {string} payload.tier - The tier of the report (default is 'ALL').
 * @param {string} payload.version - The version of the report (default is '2').
 * @returns {Promise<string>} - The URL of the exported report file.
 */
const exportReportData = async ({ wabaId, startDate, endDate, phoneNumbers, tier = 'ALL', version = '2' }) => {
  const response = await fetch(
    `${BASE_URL}/report/pricinganalytics/export`,
    getHeaders('POST', {
      wabaId,
      startDate,
      endDate,
      phoneNumbers,
      tier,
      version,
    }),
  )

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)

  return url
}

const downloadHsmReportFile = async (url) => {
  const filename = `messages-report-${new Date().getTime()}.csv`
  downloadFile(filename, url)
}

function useExportPricingAnalyticReport() {
  return useMutation({
    mutationKey: ['export-pricing-analytic-report-data'],
    mutationFn: async ({ wabaId, startDate, endDate, phoneNumbers, tier = 'ALL', version = '2' }) =>
      exportReportData({ wabaId, startDate, endDate, phoneNumbers, tier, version }),
    onSuccess: (result) => {
      downloadHsmReportFile(result)
    },
    retry: 1,
  })
}

export default useExportPricingAnalyticReport
